/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState} from "react";
import AppContainer from "../Components/Structure/AppContainer";
import AuthContext from "../Context/AuthContext";
import { Toaster} from "react-hot-toast";
import SchoolContext from "../Context/SchoolContext";
import useStateCallback from "../util/customHooks/useStateCallback";
import TurnOnCallRestrictions from "../Components/Schools/TurnOnCallRestrictions";
import TurnOffCallRestrictions from "../Components/Schools/TurnOffCallRestrictions";
import SummaryCount from "../Components/SchoolDashboard/SummaryCount";
import CardContext from "../Context/CardContext";
import UpdateDashboardSchool from "../Components/SchoolDashboard/UpdateDashboardSchool";
import SchoolVendors from "../Components/SchoolDashboard/SchoolVendors";
import { Link } from "react-router-dom";
import ajaxUser from "../util/remote/ajaxUser";
import StationContext from "../Context/StationContext";
import SchoolActivations from "../Components/SchoolDashboard/SchoolActivations";

function SchoolDashboard() {
  const {schoolID, schoolDashboardVendors, getSchoolDashboardVendors} = useContext(StationContext);
  const { user, userId } = useContext(AuthContext);
  const { setSchoolId, schoolDetails, studentCount, schoolContactsCount } = useContext(SchoolContext);
  const [modal, setModal] = useStateCallback(false);
  const {countSchoolAssignedCards, schoolAssignedCardsCount, schoolAssignedWristbandsCount, countSchoolAssignedWristbands} = useContext(CardContext);
  const [recentActivations, setRecentActivations] = useState([]);
 
  useEffect(() => {
    setSchoolId(schoolDetails.school_id);
  }, [schoolDetails.school_id, setSchoolId]);

  useEffect(() => {
    countSchoolAssignedCards();
    getSchoolDashboardVendors();
    countSchoolAssignedWristbands();
   
  }, [schoolID]);

  useEffect(() => {
    getRecentActivations();
   
  }, [schoolDetails.school_id]);

  const getRecentActivations = async () => {
    const server_response = await ajaxUser.fetchRecentSchoolDashboardActivations(schoolDetails.school_id);
    if (server_response.status === "OK") {
      setRecentActivations(server_response.details);
    } else {
      setRecentActivations([]);
    }
  };

  const restrictionsOn=()=>{
    setModal(false, ()=>setModal(<TurnOnCallRestrictions schoolID={schoolDetails.school_id} isOpen={true}/>))
  }

  const restrictionsOff=()=>{
    setModal(false, ()=>setModal(<TurnOffCallRestrictions schoolID={schoolDetails.school_id} isOpen={true}/>))
  }

  const updateSchool=()=>{
    setModal(false, ()=>setModal(<UpdateDashboardSchool adminID={schoolDetails.admin_id} isOpen={true}/>))
  }


  return (
    <AppContainer title={"Dashboard"}>
      <Toaster position="top-center" reverseOrder={false} />
      {modal}
      <div className="row">
        <div class="col-4-xxxl col-lg-4 col-12">
          <div class="card dashboard-card-ten">
            <div class="card-body gradient-my-blue">
              <div class="heading-layout1">
                <div class="item-title">
                  <h3 style={{ color: "white" }}>Welcome!</h3>
                </div>
              </div>
              <div class="student-info">
                <div class="media media-none--xs">
                  <div class="item-img" style={{backgroundColor: "white"}}>
                    <img src={process.env.PUBLIC_URL + "/assets/img/figure/user55.png"} style={{ marginBottom: "15px" }} alt="School Admin"/>
                  </div>
                  <div class="media-body">
                    <h3 class="item-title" style={{ color: "white" }}>{user.full_name}</h3>
                    <p style={{ color: "white" }}> School Administrator</p>
                  </div>
                </div>
                <div className="table-responsive">
                  <table className="table mt-2 mw-100 color-span">
                    <tbody>
                      <tr>
                        <td className="py-2 px-0" style={{ color: "white" }}>{" "}
                          <span className="w-50">School Name </span>{" "}
                        </td>
                        <td style={{ color: "white" }}>:</td>
                        <td className="py-2 px-0" style={{ color: "white" }}>{" "}
                          <span className="">
                            <b>{schoolDetails.school_name}</b>
                          </span>{" "}
                        </td>
                      </tr>
                      <tr>
                        <td className="py-2 px-0" style={{ color: "white" }}>{" "}
                          <span className="w-50">School Code </span>{" "}
                        </td>
                        <td style={{ color: "white" }}>:</td>
                        <td className="py-2 px-0" style={{ color: "white" }}>{" "}
                          <span className="">
                            <b>{schoolDetails.school_code}</b>
                          </span>{" "}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="social-links mt-2 align-items-center ">
                
                  {schoolDetails.school_restrictions === "0"?
                    <Link onClick={restrictionsOn} className="btn btn-warning mr-2"><i className="fa fa-power-off mr-1" style={{color:"green"}}></i>Turn On Call Restrictions</Link>
                  :
                    <Link onClick={restrictionsOff} className="btn btn-warning mr-2"><i className="fa fa-power-off mr-1" style={{color:"red"}}></i>Turn Off Call Restrictions</Link>
                  }

                  {["7", "2059", "2978"].includes(userId) ? (
                    <Link onClick={updateSchool} className="btn btn-info ml-2">
                      <i className="fa fa-edit mr-1" style={{ color: "white" }}></i>
                      Change School
                    </Link>
                  ) : null}

                </div>
              </div>
            </div>
          </div>
        </div>
        
        <SummaryCount studentsNumber={studentCount}  schoolAssignedCardsCount={schoolAssignedCardsCount}
        schoolAssignedWristbandsCount={schoolAssignedWristbandsCount} schoolContacts={schoolContactsCount}/>

      </div>

      <div className="row">
        <SchoolActivations schoolDashboardActivations={recentActivations}/>

        <SchoolVendors vendorTransactionStatus={schoolDashboardVendors}/>


        {/* <SchoolLogsChart/> */}
      </div>
    </AppContainer>
  );
}

export default SchoolDashboard;
